export default __webpack_public_path__ + "0794235e728a66196e1e1b7078357b13.svg";